import styled from 'styled-components';
import catImage from '@/public/images/Cancellation.svg';
import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import CrossSVG from '@/assets/Icons/close.svg';

export const CustomModal = styled(MobileOrDesktopDialog)`
    & .MuiPaper-root {
        padding: 32px 20px 0px 20px;
        border-radius: 20px 20px 0px 0px;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
`;

export const Inner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const PhotoBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
`;
export const Photo = styled.div`
    width: 88px;
    height: 88px;
`;

export const CatImage = styled(catImage)`
    width: 88px;
    height: 88px;
    flex-shrink: 0;
`;

export const Cross = styled(CrossSVG)`
    width: 24px;
    height: 24px;
`;

export const BodyAfterPhoto = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    align-self: stretch;
`;
export const TextItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-self: stretch;

    span {
        color: #121212;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: -0.1px;
    }

    p {
        color: #4b4b4b;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin: 0px 0px;
    }
`;

export const ListItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
`;

export const ListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: #121212;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
`;

export const CTAWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 12px 20px 20px 20px;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    span {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
`;
